import i18n from "../../i18n";

export function useDetectLanguage() {
  return i18n.language;
}